import { render, staticRenderFns } from "./peoList.vue?vue&type=template&id=44c3d267&scoped=true&"
import script from "./peoList.vue?vue&type=script&lang=js&"
export * from "./peoList.vue?vue&type=script&lang=js&"
import style0 from "./peoList.vue?vue&type=style&index=0&id=44c3d267&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3d267",
  null
  
)

export default component.exports